import {FC} from "react";
import {Modal} from "antd";
import {LoginModalProps} from "../../../types/auth";
import LoginForm from "./components/login-form/LoginForm";
import {LoginOutlined} from "@ant-design/icons";

const LoginModal: FC<LoginModalProps> = (props) => {
  const {authController} = props
  const {isModalOpen, toggleModalVisible, authForm, isLoading} = authController

  const okButtonHandler = () => {
    authForm.submit()
  }
  return <Modal className="login-modal" width={440} centered
                title={<div className="login-modal__title">
                  <span className="login-modal__icon"><LoginOutlined/></span>
                  <span>Вхід до облікового запису</span>
                </div>}
                open={isModalOpen} onOk={okButtonHandler}
                onCancel={toggleModalVisible}
                okText="Увійти" cancelText="Скасувати" confirmLoading={isLoading}
                cancelButtonProps={{disabled: isLoading}} closable={!isLoading} maskClosable={!isLoading} keyboard={!isLoading}>
    <p className="login-modal__description">Увійдіть, щоб отримати доступ до робочих розділів закладу.</p>
    <LoginForm authController={authController}/>
  </Modal>
}

export default LoginModal
